export default {
    locale_code: "en-US",
    sms: "SMS",
    rcs: "RCS",
    email: "Email",
    whatsapp: "WhatsApp",
    webhook: "Webhook",
    ia_basic: "Basic AI",
    ia_advanced: "Advanced AI",
    scheduled: "Scheduled",
    sent: "Sent",
    accepted: "Accepted",
    queued: "Processing",
    failed: "Failed",
    text: "Text",
    date: "Date",
    user: "User",
    textarea: "Long text",
    number: "Number",
    coupon: "Discount coupon",
    checkbox: "Checkbox",
    currency_symbol: "$",
    percent_symbol: "%",
    active: "Active",
    add: "Add",
    archived: "Archived", 
    back: "Back",
    brand: "Brand",
    category: "Category",
    delete: "Delete",
    fields: "Fields", 
    no_results_found: "No results found",
    options: "Options",
    paused: "Paused",
    price: "Price",
    product: "Product",
    quantity_short: "Qty",
    remove: "Remove",
    undo: "Undo",
    search: "Search",
    select: "Select",
    total: "Total", 
    type: "Type",
    unavailable: "Unavailable",
    value: "Value",
    whatsapp_file_preview: "WhatsApp file preview",
    username: "Username", 
    plugin: "Plugin",
    two_factor_auth: "Two-factor authentication",
    ces_score: "CES Score",
    nps_score: "NPS Score",
    valid_between: "Valid between",
    days_ago: "{0} days ago",
    today: "Today",
    tomorrow: "Tomorrow",
    in_x_days: "In {0} days",
    yes: "Yes",
    no: "No",
    outside_journey: "Outside Journey",
    whatsapp_official: "WhatsApp Official",
    kevi_title_prefix: "Kevi",
    error: "Error",
    unknown: "Unknown",
    tasks: "Tasks",
    "tasks-label": "Tasks",
    support: "Support",
    dates: {
        month: "month",
        week: "week",
        day: "day",
        year: "year",
        week_day: "weekday",
        hour: "hour",
        Mon: "Mon",
        Tue: "Tue",
        Wed: "Wed",
        Thu: "Thu",
        Fri: "Fri",
        Sat: "Sat",
        Sun: "Sun",
        full_months: {
            "0": "january",
            "1": "february",
            "2": "march",
            "3": "april",
            "4": "may",
            "5": "june",
            "6": "july",
            "7": "august",
            "8": "september",
            "9": "october",
            "10": "november",
            "11": "december",
        },
        full_weekdays: [
            "sunday",
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
        ],
        default_format: "[MM] [d], [Y]",
        format_day_month_long: "[MM] [d]",
        format_full_date: "[MM] [d], [YY]",
        format_day_month_short: "[d]/[M]",
        format_day_month_short_time: "[d]/[M] at [h]:[m]",
        format_date_2y: "[d]/[MM]/[Y]",
        format_date: "[d]/[M]/[Y]",
        format_date_time: "[d]/[M]/[Y] at [h]:[m]",
        format_date_time_seconds: "[d]/[M]/[Y] at [h]:[m]:[s]",
        format_date_time_weekday: "[d]/[M]/[Y] at [h]:[m] - [D]:ucf",
        format_date_weekday: "[d]/[M]/[Y] ([D])",
        format_date_time_simple: "[d]/[M]/[Y] [h]:[m]",
        format_date_time_comma: "[d]/[M]/[Y], [h]:[m]",
        format_date_4y: "[d]/[M]/[YY]",
        format_weekday_date: "[D]:ucf - [d]/[M]/[Y]",
        format_weekday_date_time: "[D]:ucf - [d]/[M]/[Y] at [h]:[m]",
        format_time: "[h]:[m]",
        format_month_year: "[MM]/[YY]",
        format_year: "[YY]",
        month_names: {
            "0": "January",
            "1": "February",
            "2": "March", 
            "3": "April",
            "4": "May",
            "5": "June",
            "6": "July",
            "7": "August",
            "8": "September",
            "9": "October",
            "10": "November",
            "11": "December"
        }
    },
    inputs: {
        datepicker: {
            month: "Month",
            year: "Year",
            time: "Time:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Now",
            today: "Today",
            clear: "Clear",
            confirm: "Confirm",
            weekdays: {
                sun: "Sun",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat",
            },
        },
    },
    rfm_groups: {
        cant_lose: "Can't lose",
        champion: "Champions",
        loyal: "Loyal",
        needs_attention: "Needs attention",
        potential_champion: "Potential loyal",
        new: "New",
        promising: "Promising",
        about_to_sleep: "About to sleep",
        at_risk: "At risk",
        hibernating: "Hibernating",
        lost: "Lost",
    },
    sender_options: {
        token: "Token",
        from: "From",
        from_name: "Sender name",
        from_email: "Sender email",
        from_phone: "Sender phone",
        whatsapp_business_id: "WhatsApp Business ID",
        phone_number_id: "Phone number ID",
        domain: "Domain",
        account_token: "Account token",
        access_token: "Access token",
        refresh_token: "Refresh token",
        api_key: "API key",
        channel_id: "Channel ID",
        client_id: "Client ID",
        secret_id: "Client secret",
        email: "Email",
        password: "Password",
        slug: "Slug",
        id: "ID",
        instance_token: "Instance token",
        instance_code: "Instance code",
        instance_id: "Instance ID",
        subdomain: "Subdomain",
        api_access_token: "API access token",
        account_id: "Account ID",
        inbox_id: "Inbox ID",
        chatwoot_url: "Chatwoot URL",
        meta_access_token: "Meta access token",
        base_url: "Base URL",
    },
    filter_bar: {
        add_filter: "Add Filter",
        select_filter: "Select a filter",
        clear_filter: "Clear filter",
        period: "Period",
        branches: "Branches",
        client: "Client",
        form: "Form",
        avg_ticket: "Average Ticket",
        orders_amount: "Number of orders",
        customer_profile: "Customer profile",
        with_complete_registration: "With complete registration",
        without_complete_registration: "Without complete registration",
        points_balance: "Points Balance",
        client_segments: "Client segment",
        client_segments_not: "Not in segment",
        last_order_period: "Last order period",
        min_period_between_executions: "Minimum time between executions",
        last_order_branch: "Last order branch",
        clients_limit: "Client limit",
        value: "Value",
        automation_title: "Automation title",
        type: "Type",
        campaigns: "Campaigns",
        automations: "Automations",
        status: "Status",
        active: "Active",
        paused: "Paused",
        deleted: "Deleted",
        first_order_period: "First order period",
        order_status: "Order Status",
        file_type: "File Type",
        file_preview: "File preview",
        whatsapp_file_preview: "WhatsApp file preview",
        image: "Image",
        pdf: "PDF",
        video: "Video",
        audio: "Audio",
        other: "Other",
        purchased_in_period: "Purchased in period",
        registration_date: "Registration date",
        name_phone_email_or_code: "Name, phone, email or code",
        coupon_code: "Coupon code",
        expiration_date: "Expiration date",
        usage_date: "Usage date",
        automation: "Automation",
        situation: "Situation",
        available: "Available",
        used: "Used",
        expired: "Expired",
        accepted: "Accepted",
        scheduled: "Scheduled",
        sent: "Sent",
        failed: "Failed",
        processing: "Processing",
        method: "Method",
        quotation_status: "Quotation Status",
        responsible: "Responsible",
        task_deadline: "Task deadline",
        creation_date: "Creation date",
        completion_date: "Completion date",
        pending: "Pending",
        completed: "Completed",
        archived: "Archived",
        quotations_amount: "Number of quotations",
        quotations_value: "Quotation value",
        rfm_group: "RFM Group",
        campaign_interactions: "Campaign Interactions",
        days_after: "Days after ",
        custom_event: "Custom Event",
        purchased_product: "Purchased product",
        with_phone: "With phone",
        with_email: "With email",
        accumulated_spending_clv: "Accumulated spending (CLV)",
        days_since_last_order: "Days since last order",
        days_since_first_order: "Days since first order",
        predicted_days_until_next_order: "Predicted days until next order",
        days_since_registration: "Days since registration",
        age: "Age",
        month_birthday: "Month's birthdays",
        communication_channels: "Communication Channels",
    },
    user_notifications: {
        edited_task: "{$0} edited task {$1}",
        commented_on_task: "{$0} commented on task {$1}",
        completed_task: "{$0} completed task {$1}",
        archived_task: "{$0} archived task {$1}",
        moved_task_to_column: "{$0} moved task {$1} to column {$2}",
        beta_admin_only: "Beta: Available only for administrators",
        no_notifications: "No notifications",
        mark_all_read: "Mark all as read",
    },
    searchSelect: {
        placeholder: "Search...",
        client_placeholder: "Search client...",
        clear: "Clear",
        loading: "Searching...",
        empty: "No results found",
        hint: "Type at least {0} characters to search",
        close: "Close",
    },
    confirm_phrase: {
        instruction: "Type the following phrase to confirm the action:",
        placeholder: "Type the confirmation phrase here",
    },
    info_modal: {
        close: "Close",
    },
    kv_search_select: {
        loading: "Searching...",
        empty: "No results found",
        hint: "Type at least {$0} character to search",
        close: "Close",
        clear: "Clear",
        placeholder: "Search...",
    },
    clients_field: {
        placeholder: "Search client",
        aria_label: "Search client",
    },
    filter_group: {
        and_all: "AND (all filters)",
        or_any: "OR (any filter)",
        not_exclude: "NOT (exclude)",
        add_filter: "Add Filter",
        add_group: "Add Group",
        no_filters: "No filters available",
        empty_state: "Add filters or groups to create your condition",
        remove_filter: "Remove filter",
    },
    charts: {
        totals: "Totals",
    },
    code_editor: {
        placeholder: "Paste your code here...",
        cancel: "Cancel",
        save: "Save",
    },
    confirm: {
        cancel: "Cancel",
        confirm: "Confirm",
        close: "Close",
    },
    editor: {
        bold: "Bold",
        italic: "Italic", 
        underline: "Underline",
        strikethrough: "Strikethrough",
        heading1: "Heading 1",
        heading2: "Heading 2", 
        bullet_list: "Bullet List",
        numbered_list: "Numbered List",
        undo: "Undo",
        redo: "Redo",
        link: "Link",
        body_font: "(Body font)",
        line_height: "Line height",
    },
    custom_fields: {
        not_informed: "Not informed",
        not_found: "Not found",
        select_user: "Select user",
    },
    custom_image: {
        change: "Change",
        get_from_computer: "Get from computer",
        clean: "Clear",
    },
    datetime: {
        clear_date: "Clear date",
    },
    copy_button: {
        copy: "Copy",
        copied: "Copied!",
        copy_failed: "Failed to copy:",
    },
    grapejs: {
        blocks: {
            sect100: "1 Column",
            sect50: "2 Columns",
            sect30: "3 Columns",
            sect37: "2 Columns",
            button: "Button",
            divider: "Divider",
            text: "Text",
            "text-sect": "Text Section",
            image: "Image",
            quote: "Quote",
            grid_items: "Grid",
            list_items: "List",
            link: "Link",
            link_block: "Block de enlace",
        },
        save_email: "Save email",
        save: "save",
        cancel: "cancel",
        edit_menu: "Edit Menu",
        tokens: "Tokens:",
    },
    inputs: {
        keyvalue: {
            field: "Field",
            value: "Value",
            placeholder_key: "Ex: name",
            placeholder_value: "Ex: name",
            placeholder_value_template: "Ex: [[client.name]]",
            add_field: "Add field",
        },
        datepicker: {
            month: "Month",
            year: "Year",
            time: "Time:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Now",
            today: "Today",
            clear: "Clear",
            confirm: "Confirm",
            weekdays: {
                sun: "Sun",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat",
            },
        },
        color: {
            title: "Color",
            open: "Open color picker",
            hex: "#000000",
            basics: "Basics",
            hue: "Hue",
            saturation_brightness: "Saturation and brightness",
            saturation_brightness_value: "Saturation {0}%, brightness {1}%",
        },
        image: {
            title: "Upload image",
            description: "Drag and drop or select a JPG or PNG file.",
            button: "Select file",
            delete: "Remove image",
            defaultName: "Image",
            success: "Upload completed successfully!",
            deleted: "Image removed successfully!",
            deleteModalTitle: "Remove image",
            deleteModalDescription: "Are you sure you want to remove this image?",
            deleteModalCancel: "Cancel",
            deleteModalConfirm: "Remove",
            statusCompleted: "Completed",
            statusUploading: "Uploading...",
            statusError: "Upload failed",
            oversized: "The maximum size per image is {0}MB. The following images exceeded the limit: {1}",
            parseError: "Error parsing server response.",
            serverError: "A server error occurred while trying to send the images.",
            httpError: "Error {0} during upload.",
            networkError: "Network error. Please check your internet connection.",
        },
        daterangepicker: {
            today: "Today",
            yesterday: "Yesterday",
            this_month: "This month",
            this_year: "This year",
            last_month: "Last month",
            last_year: "Last year",
            all_period: "All period",
            cancel: "Cancel",
            apply: "Apply",
        },
        editor: {
            bold: "Bold",
            italic: "Italic",
            underline: "Underline",
            strike: "Strike",
            h1: "Heading 1",
            h2: "Heading 2",
            list: "List",
            ordered_list: "Ordered List",
            undo: "Undo",
            redo: "Redo",
            placeholder: "Type here...",
        },
        validation: {
            invalid_value: "Invalid value",
            validation_error: "Validation error",
        },
        select: {
            loading: "Loading...",
            placeholder: "Select...",
            search_placeholder: "Search...",
            empty_text: "No options found",
        },
    },
    reports: {
        filter_name: "Filter name",
        template_unavailable: "Template unavailable",
        video_tag_not_supported: "Your browser does not support the video tag.",
    },
    min: "Min",
    max: "Max",
    image: "Image",
    double_click_to_add_image: "Double click to add an image",
    visual_editor: {
        alignment: "Alignment",
        left: "Left",
        center: "Center",
        right: "Right",
        aspect_ratio: "Aspect ratio",
        auto: "Auto",
        automatic: "Automatic",
        drag_block: "Drag block",
        duplicate: "Duplicate",
        delete: "Delete",
        border: "Border",
        solid: "Solid",
        dashed: "Dashed",
        dotted: "Dotted",
        spacing: "Spacing",
        top: "Top",
        bottom: "Bottom",
        custom_settings: "Custom settings",
        display: "Display",
        block: "Block",
        inline: "Inline",
        drag_row: "Drag row",
        drag_blocks_here: "Drag blocks here",
        no_settings: "No settings found.",
        vertical: "Vertical",
        horizontal: "Horizontal",
        back_to_simple_mode: "Back to simple mode",
        vertical_alignment: "Vertical alignment",
        middle: "Middle",
        width_unit: "Width unit",
        percent: "Percent",
        fixed_pixels: "Fixed pixels",
    },
    cancel: "Cancel",
    apply: "Apply",
    save: "Save",
    edit: "Edit",
    actions: "Actions",
    status: "Status",
    id: "Id",
    name: "Name",
    phone: "Phone",
    title: "Title",
    all: "All",
    loading: "Loading...",
    yes: "Yes",
    no: "No",
    external_id: "External Id",
    internal_server_error: "Internal Server Error, please try again later.",
    export: "Export",
    expiration_date: "Expiration Date",
    client: "Client",
    places: {
        details: {
            access_denied: "Access denied",
            view_as: "View as {name}",
            manage_plan: "Manage Plan",
            block: "Block",
            activate: "Activate",
            automations_locked: "Automations {status}",
            place_blocked: "Place blocked",
            place_activated: "Place activated",
            automations_on: "activated",
            automations_off: "deactivated",
            activate_automations: "Activate automations",
            deactivate_automations: "Deactivate automations",
        },
        branches: {
            title: "Branches",
            neighborhood_city: "Neighborhood / City",
            add_branch: "Add Branch",
        },
        modules: {
            title: "Modules",
            updated: "Modules updated!",
        },
        plugins: {
            title: "Plugins",
            add_plugin: "Add Plugin",
            choose_plugin: "Choose Plugin",
            external_id: "External Id",
            created_at: "Created at",
            settings_updated: "Settings updated",
        },
        roles: {
            title: "Roles",
            new_role_placeholder: "New role",
            role_added: "Role added",
            role_updated: "Role updated",
            role_deleted: "Role Deleted",
        },
        users: {
            title: "Users",
            add_user: "Add User",
            active: "Active",
        },
    },
    quotations: {
        report_title: "Quotations Report",
        budget_and_billing_by: "Budget and Billing by",
        group_by: "Group by:",
        billing: "Billing",
        budget: "Budget",
        sent: "Quotations Sent",
        clients: "Clients",
        average_ticket: "Average Ticket",
        awaiting_approval: "Awaiting Approval",
        approved: "Quotations Approved",
        rejected: "Quotations Rejected",
    },
    inbox: {
        filters: {
            select_status: "Select status",
            new: "New",
            pending: "Pending",
            solved: "Solved",
        },
    },
    segments: {
        filters: {
            birthdays_of_month: "Birthdays of month",
            period_label: "Period: {period} days ago.",
            limit_time_range: "Limit time range",
            days_ago: "Days ago",
            inform_values: "Inform values",
            until: "Until",
            from: "From",
            between: "Between",
            and: "and",
            more_than: "More than",
            select_values: "Select values",
            indifferent: "Indifferent",
            accepted: "Accepted",
            not_accepted: "Not accepted",
            event: "Event",
            executions: "executions",
            which_event: "Which event?",
            search_event: "Search event...",
            limit_by_values: "Limit by values",
            search_combined_info: "The search considers only the informed fields, always combined",
            which_product: "Which product?",
            which_category: "Which category?",
            which_brand: "Which brand?",
            purchase_quantity: "Purchase quantity",
            purchases: "purchases",
            which_status_to_execute: "In which status to execute?",
        },
    },
    settings: {
        journey: {
            title: "Customer journey",
            stages: "Stages",
            insert_first_stage: "Insert the first stage",
            insert_first_substage: "Insert the first sub-stage",
            board_renamed: "Board renamed",
            board_prefix: "Board",
            add_stage_placeholder: "Add stage...",
            order_saved: "Order saved",
            stage_renamed: "Stage renamed",
        },
        plugins: {
            title: "Senders",
            sender: "Sender",
            monthly_value: "Monthly value",
            cost_per_message: "Cost per message",
            credits: "credits",
            none_registered: "No senders registered",
            edit_sender: "Edit sender {name}",
            register_sender: "Register sender",
            soon: "Soon",
            send_test_to: "Send test to:",
            save_changes: "Save changes",
            add_sender: "Add Sender",
            sender_saved_test_sent: "Sender saved, test sent",
        },
        products: {
            title: "Products",
            no_images: "No images",
            cost: "Cost",
            brand: "Brand",
            stock: "Stock",
            external_id: "External ID",
            orders_12m: "Orders (12m)",
            revenue_12m: "Revenue (12m)",
            current_price: "Current price",
            last_purchase: "Last purchase",
            purchase_history: "Purchase History",
            bought_together: "Bought Together",
            also_bought: "Also Bought",
            ai: "AI",
            manual: "Manual",
            last_10_orders_including_product: "Last 10 orders including this product.",
            price_unit: "Unit Price",
            bought_in_same_order: "Products that were bought in the same order as this. Based on the last 90 days of sales.",
            clients_who_bought_also_bought: "Products that clients who bought this also bought in other orders. Based on the last 90 days.",
            ai_recommendation_disclaimer: "AI Recommendation: these options are not saved in the product. Instead, each automation decides when and how to make the AI match.",
            ai_placeholder: "Who bought X might also like...",
            use_ai: "Use AI",
            manual_recommendation_disclaimer: "Add related products quickly. Then, if you want, you can include a recommendation (reason) for each link.",
            search_product_to_link: "Search product to link...",
            added_products: "Added products",
            no_manual_links: "No manual products linked yet.",
            add_recommendation_optional: "Add recommendation (optional)",
            link_removed: "Link removed",
            product_linked: "Product linked",
            recommendation_saved: "Recommendation saved",
            product_not_found: "Product not found.",
            manage_groups: "Manage groups",
            add_to_group: "Add to group",
            remove_from_group: "Remove from group",
            new_group: "New group",
            group_name: "Group name",
            batch_edit: "Batch edit",
            repurchase_days: "Days for repurchase",
            group: "Group",
            groups: "Groups",
            products_updated: "Products updated",
            group_updated: "Group updated",
            something_went_wrong: "Ops, something went wrong",
        },
        translations: {
            title: "Translations",
            description: "Edit translations by category and language. Changes are saved when leaving the field.",
            locale: "Language",
            no_categories_found: "No translation category found.",
            items_for: "item(s) for",
            no_translations_found: "No translation found in this category.",
            key: "Key",
            original_en: "Original (EN)",
            translated: "Translated",
            saving: "Saving...",
            saved: "Saved",
            error_saving: "Error saving",
            unable_to_load: "Unable to load translations",
            unable_to_load_items: "Unable to load category items",
        },
    },
    smart_insertion: {
        title: "Smart Insertions",
        register_space: "Register Space",
        name_id: "Name (id)",
        short_text: "Short Text",
        long_text: "Long Text",
        html: "HTML",
        add_field: "Add Field",
        required: "Required",
    },
};
